import PasswordInput from './PasswordInput';

function FormInput({
  id,
  label = null,
  error = null,
  placeholder = '',
  formFieldType,
  isRequired,
  register,
  isDisabled = false,
  ...attrs
}) {
  const formFieldClassName = formFieldType === 'text' ? 'input' : formFieldType;
  return (
    <div className={`blaze-user-form__input-group__input ${formFieldClassName} ${id}`}>
      <div className={`form-field form-field--${formFieldClassName}`}>
        {!!label && (
          <label className={isRequired ? 'required' : ''}>
            <span>{label}</span>
          </label>
        )}

        {renderInput({
          id,
          placeholder,
          formFieldType,
          register,
          error,
          isDisabled,
          ...attrs
        })}
        {error && (
          <div className="validation">
            <i className="material-icons">warning</i>
            <span>{error.message}</span>
          </div>
        )}
      </div>
    </div>
  );
}

const renderInput = ({ ...props }) => {
  const { formFieldType: type, id, register, error, placeholder, isDisabled } = props;
  const inputClassName = error ? 'error-field' : '';

  switch (type) {
    case 'password':
      return (
        <PasswordInput
          id={id}
          placeholder={placeholder}
          className={inputClassName}
          register={register}
        />
      );
    default:
      return (
        <input
          id={id}
          type={type ?? 'text'}
          placeholder={placeholder}
          {...register(id)}
          disabled={isDisabled}
          className={inputClassName}
        />
      );
  }
};

export default FormInput;
